import { useContext } from 'react';
import { IToastMessageContextValues, ToastMessageContext } from '../contexts/toastMessageContext';

export const useToastMessage = (): IToastMessageContextValues => {
    const context = useContext(ToastMessageContext);

    if (!context) {
        throw new Error('useToastMessage must be used within a ToastMessageProvider');
    }

    return context;
};
